// base_bulk_action_control 1  BulkSelectionToolbar
import React, {
    useState,
    useEffect,
    useImperativeHandle,
    forwardRef,
} from "react"
import { Button, Checkbox, Badge, Row, Col, DeleteButton } from './ot'

const BaseBulkActionControl1 = forwardRef(({
    checkedAll = false,
    onToggleAll = () => { },
    selectedCount: externalSelectedCount = 0,
    selectedTotal = 0,
    actionList = [{ label: "批次刪除", value: "delete", type: "popconfirm", popconfirmTitle: "確認執行此操作？", popconfirmDescription: "您即將對所選項目執行此操作。此操作無法復原。" }],
    onActionClick = () => { },
    selectLabel = "選擇本頁所有項目",
    selectCountBadge = true,
    showComponent = ["BaseBulkActionControl1_1", "BaseBulkActionControl1_2", "BaseBulkActionControl1_3"]

}, ref) => {
    const [selectedCount, setSelectedCount] = useState(externalSelectedCount)

    useEffect(() => {
        setSelectedCount(externalSelectedCount)
    }, [externalSelectedCount])

    useImperativeHandle(ref, () => ({
        getCheckBoxAll: () => {
            return (
                showComponent.includes("BaseBulkActionControl1_1") &&
                (<div className="flex items-center gap-2">
                    <Checkbox
                        checked={checkedAll}
                        onCheckedChange={onToggleAll}
                    >
                        {selectLabel ||"全選"}
                    </Checkbox>
                    {selectCountBadge && <Badge variant="secondary" className="ml-2">
                        {selectedTotal}
                    </Badge>}
                </div>)

            )
        }
    }), [checkedAll, onToggleAll, selectLabel, selectedTotal])

    return (
        <Row>
            <Col span={24}>
                {selectedCount > 0 &&
                    (showComponent.includes("BaseBulkActionControl1_2") || showComponent.includes("BaseBulkActionControl1_3"))
                    && (
                        <div className="flex items-center gap-2 mb-2 p-2 bg-muted rounded-md">
                            {showComponent.includes("BaseBulkActionControl1_2") && <span className="text-sm font-medium">
                                已選擇 {selectedCount} 項
                            </span>}
                            {
                                showComponent.includes("BaseBulkActionControl1_3") && actionList.map((value) => {
                                     
                                    if (value?.type === "popconfirm") {
                                        return (<DeleteButton
                                            key={value?.value}
                                            onConfirm={() => {
                                                onActionClick(value?.value)
                                            }}
                                            title={value?.popconfirmTitle || "確認執行此操作？"}
                                            description={value?.popconfirmDescription || "您即將對所選項目執行此操作。此操作無法復原。"}
                                        >
                                            {/* <Button
                                                variant="outline"
                                                size="sm"
                                            > */}
                                                {value?.label}
                                            {/* </Button> */}
                                        </DeleteButton>)
                                    }
                                    else {
                                        return (<Button
                                            variant="outline"
                                            size="sm"
                                            onClick={() => {
                                                onActionClick(value?.value)
                                            }}
                                        >
                                            {value?.label}
                                        </Button>)
                                    }

                                })
                            }
                        </div>
                    )}
            </Col>
        </Row>
    )
})

export default BaseBulkActionControl1
